import { render } from "./AnnouncementSingleComponent.vue?vue&type=template&id=9e255abc&scoped=true&ts=true"
import script from "./AnnouncementSingleComponent.vue?vue&type=script&lang=ts"
export * from "./AnnouncementSingleComponent.vue?vue&type=script&lang=ts"

import "./AnnouncementSingleComponent.vue?vue&type=style&index=0&id=9e255abc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e255abc"]])

export default __exports__